// extracted by mini-css-extract-plugin
export default {"saveButton":"SaveOption_saveButton__3hYpV","saveBtnLabel":"SaveOption_saveBtnLabel__iyIWk"};